import React from 'react';
import './DbSection.css';

interface Props {
  children: React.ReactNode;
}

const DbSection: React.FC<Props> = ({ children }) => (
  <div className="db-section-wrapper">
    <span className="db-section-badge">⚡ From Database</span>
    {children}
  </div>
);

export default DbSection;
